module.exports = __webpack_public_path__ + "static/media/coupon.db32333a.svg";